"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCryptors = void 0;
const crypto_1 = require("crypto");
const keyDerivation_1 = require("./keyDerivation");
const ENCRYPTION_ALGORITHM = 'des';
const CHAR_ENCODING = 'utf8';
const OUTPUT_ENCODING = 'hex';
const createEncryptor = ({ key, iv }) => (payload) => {
    const cipher = crypto_1.createCipheriv(ENCRYPTION_ALGORITHM, key, iv);
    const payloadCipher = cipher.update(payload, CHAR_ENCODING, OUTPUT_ENCODING);
    const finalisedCipher = cipher.final(OUTPUT_ENCODING);
    const encryptedPayload = payloadCipher + finalisedCipher;
    const upperCaseEncryptedPayload = encryptedPayload.toUpperCase();
    return upperCaseEncryptedPayload;
};
const createDecryptor = ({ key, iv }) => (payload) => {
    const payloadBuffer = Buffer.from(payload, OUTPUT_ENCODING);
    const decipher = crypto_1.createDecipheriv(ENCRYPTION_ALGORITHM, key, iv);
    const payloadDecipher = decipher.update(payloadBuffer);
    const finalisedDecipher = decipher.final();
    const decryptedPayload = Buffer.concat([
        payloadDecipher,
        finalisedDecipher,
    ]).toString();
    return decryptedPayload;
};
exports.createCryptors = ({ password, salt, iterations, }) => {
    const { key, iv } = keyDerivation_1.getKeyIV({ password, salt, iterations });
    const encrypt = createEncryptor({ key, iv });
    const decrypt = createDecryptor({ key, iv });
    return { encrypt, decrypt };
};
//# sourceMappingURL=idEncryption.js.map